export const CURRENT_CONFIG = {

  // 授权
  appId: import.meta.env.VITE_APP_ID,
  appKey: import.meta.env.VITE_APP_KEY,
  appLicense: import.meta.env.VITE_APP_LICENSE,

  // http
  baseURL: import.meta.env.VITE_APP_APIGATEWAY_BACKEND_HOST,
  baseURLS: import.meta.env.VITE_APP_XJPT_BACKEND_HOST,
  websocketURL: import.meta.env.VITE_WEBSOCKET_URL,

  // RTMP
  rtmpURL: import.meta.env.VITE_RTMP_URL,

  // GB28181
  gbServerIp: import.meta.env.VITE_GB28181_SERVER_IP,
  gbServerPort: import.meta.env.VITE_GB28181_SERVER_PORT,
  gbServerId: import.meta.env.VITE_GB28181_SERVER_ID,
  gbAgentId: import.meta.env.VITE_GB28181_AGENT_ID,
  gbPassword: import.meta.env.VITE_GB28181_PASSWORD,
  gbAgentPort: import.meta.env.VITE_GB28181_AGENT_PORT,
  gbAgentChannel: import.meta.env.VITE_GB28181_AGENT_CHANNEL,

  // RTSP
  rtspUserName: import.meta.env.VITE_RTSP_USERNAME,
  rtspPassword: import.meta.env.VITE_RTSP_PASSWORD,
  rtspPort: import.meta.env.VITE_RTSP_PORT,

  // Agora
  agoraAPPID: import.meta.env.VITE_AGORA_APPID,
  agoraToken: import.meta.env.VITE_AGORA_TOKEN,
  agoraChannel: import.meta.env.VITE_AGORA_CHANNEL,
  agoraCertificate: import.meta.env.VITE_AGORA_CERTIFICATE,

  // MAP
  amapKey: import.meta.env.VITE_AMAP_KEY,
  amapSecrity: import.meta.env.VITE_AMAP_SECURITY,

  systemTitle: import.meta.env.VITE_SYSTEM_TITLE,
  screenTitle: import.meta.env.VITE_SCREEN_TITLE,
  loginCopyrightTitle: import.meta.env.VITE_LOGIN_COPYRIGHT_TITLE,

  // TERRA_API
  terraApiAppKey: import.meta.env.VITE_TERRA_API_APP_KEY,
  terraApiAppSecretKey: import.meta.env.VITE_TERRA_API_APP_SECRET_KEY,

  // LOGIN
  loginPublicKey: import.meta.env.VITE_LOGIN_PUBLIC_KEY,
  // SHARE
  videoSharePublicKey: import.meta.env.VITE_VIDEO_SHARE_PUBLIC_KEY,
  videoSharePrivateKey: import.meta.env.VITE_VIDEO_SHARE_PRIVATE_KEY,
}
